<div class="flex flex-col gap-4 p-4 pb-8">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-default text-xl font-bold">Personal Dashboard</h1>
      <p class="text-secondary text-sm">Your tasks, activity and financial overview</p>
    </div>
  </div>

  <!-- Filter Bar -->
  <div class="rounded-xl border bg-white px-4 py-1">
    <app-global-filter-panel [config]="filterConfig" (filtersChanged)="onFiltersChanged($event)" />
  </div>

  <!-- Key Metrics -->
  <div class="mb-2 flex items-center gap-2">
    <span class="text-xs font-bold uppercase tracking-widest text-gray-400">Key Metrics</span>
    <div class="h-px flex-1 bg-gray-100"></div>
  </div>
  <div class="mb-5">
    <app-my-statistics-counts [fromDate]="fromDate()" [toDate]="toDate()" [associationId]="associationId()"></app-my-statistics-counts>
  </div>

  <!-- My Overview -->
  <div class="mb-2 flex items-center gap-2">
    <span class="text-xs font-bold uppercase tracking-widest text-gray-400">My Overview</span>
    <div class="h-px flex-1 bg-gray-100"></div>
  </div>

  <!-- Flat 12-col grid — each card spans 4 cols (3 per row on large screens) -->
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12 h-full sm:col-span-6 lg:col-span-4">
      <app-my-todos [fromDate]="fromDate()" [toDate]="toDate()" [associationId]="associationId()"></app-my-todos>
    </div>
    <div class="col-span-12 h-full sm:col-span-6 lg:col-span-4">
      <app-management-todos [fromDate]="fromDate()" [toDate]="toDate()" [associationId]="associationId()"></app-management-todos>
    </div>
    @if ('survey_view' | canAccess) {
      <div class="col-span-12 h-full sm:col-span-6 lg:col-span-4">
        <app-my-active-surveys></app-my-active-surveys>
      </div>
    }
    <div class="col-span-12 h-full sm:col-span-6 lg:col-span-4">
      <app-my-eservices [fromDate]="fromDate()" [toDate]="toDate()" [associationId]="associationId()"></app-my-eservices>
    </div>
    <div class="col-span-12 h-full sm:col-span-6 lg:col-span-4">
      <app-recovery-rate [fromDate]="fromDate()" [toDate]="toDate()" [associationId]="associationId()" (dataLoaded)="onCollectionLoaded($event)"></app-recovery-rate>
    </div>
    <div class="col-span-12 h-full sm:col-span-6 lg:col-span-4">
      <app-payment-methods [collectionRecord]="collectionRecord"></app-payment-methods>
    </div>
    <div class="col-span-12 h-full sm:col-span-6 lg:col-span-4">
      <app-my-tasks [fromDate]="fromDate()" [toDate]="toDate()" [associationId]="associationId()"></app-my-tasks>
    </div>
    <div class="col-span-12 h-full sm:col-span-6 lg:col-span-4">
      <app-my-activity-logs [fromDate]="fromDate()" [toDate]="toDate()"></app-my-activity-logs>
    </div>
  </div>
</div>
